import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { ConvertMembershipFormSchemaValues } from 'src/features/membership/formSchema';
import { Membership } from 'src/features/membership/types';

const RESOURCE = 'sp-core/:parkingId/memberships/membership/:membershipId/convert/';

interface DTO extends ConvertMembershipFormSchemaValues {
    membershipId: string;
    parkingId: string;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({ membershipId, parkingId, ...data }: DTO): Promise<Membership> => {
    return axios.post(formatResourcePath(RESOURCE, { membershipId, parkingId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useConvertMembership };
